var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('baseExternal',{attrs:{"clazz":"full-page","showTittle":_vm.showTittle},scopedSlots:_vm._u([{key:"checkoutContainer",fn:function(){return [_c('router-view')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }